<template>
	<div>
		<b-modal
			no-close-on-backdrop
			id="applyjobmodal"
			centered
			hide-footer
			hide-header
			visible
			@hidden="$emit('close')"
		>
			<div class="d-flex">
				<div class="candash-modal-left"></div>
				<div class="width-94">
					<div class="candash-modal-top px-3 py-2">
						<div class="width-97">
							<div class="candash-modal-head">Apply for Job</div>
							<div class="candash-desc">Fill your details</div>
						</div>
						<div class="d-flex justify-content-end align-items-start pointer">
							<img
								@click="$emit('close')"
								class="rotate-on-hover"
								src="../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
							/>
						</div>
					</div>

					<div class="addcand-overflow mt-2">
						<div class="d-flex justify-content-between align-items-start w-100">
							<div class="d-flex align-items-center w-75 mt-2">
								<div>
									<img
										src="../../assets/newdesign/jobsearch/modalBigJob.svg"
										alt=""
									/>
								</div>
								<div class="ml-3">
									<div class="job-search-institute-font">
										{{ toTitleCase(job.title) }}
									</div>
									<div class="asp-grey-txt-4 mt-1 text-truncate w-100">
										{{ job.customerName }}
									</div>
								</div>
							</div>
							<main
								class="position-relative"
								v-show="allProfileList.length > 0"
							>
								<b-button
									class="candash-addBtn-sm switch-profile-btn-width"
									:disabled="allProfileList.length == 1"
									@click="showDropdown = !showDropdown"
									><img
										v-if="selectedProfile && selectedProfile.primary"
										class="mr-1"
										src="../../assets/newdesign/jobsearch/apply-primar-prof.svg"
										alt=""
									/>
									<img
										v-else
										class="mr-1"
										src="../../assets/newdesign/jobsearch/apply-prof.svg"
										alt=""
									/>
									<div
										class="switch-profile-drop-width text-left text-truncate"
									>
										{{ selectedProfile ? selectedProfile.profileName : "" }}
									</div>
									<img
										v-if="!showDropdown && allProfileList.length > 1"
										class="ml-3"
										src="../../assets/icons/candDashboard/whiteDownArrow.svg"
										alt=""
									/>
									<img
										v-else-if="showDropdown && allProfileList.length > 1"
										class="ml-3"
										src="@/assets/icons/candDashboard/whiteUparrow.svg"
										alt=""
									/>
								</b-button>
								<article
									class="apply-modal-dropdown switch-parent-radio"
									v-show="showDropdown"
								>
									<SwitchProfile
										@selected-profile="updateSelectedProfile"
										@profile-list="updateProfileList"
										@switch-profile="switchProfile"
									/>
								</article>
							</main>
						</div>
						<FormShimmer v-if="loader" :shimmer="15" :from="'applyjob'" />

						<b-row v-else>
							<b-col
								v-for="(field, index) in basicArray"
								:key="index"
								:cols="getColumn(field.controlType)"
								class="relativeclass"
								:class="
									field.controlType == 'boolean'
										? 'd-flex align-items-center'
										: ''
								"
								v-show="!field.hide && field.key != 'source'"
							>
								<div
									v-if="
										field.controlType == 'text' ||
										field.controlType == 'email' ||
										field.controlType == 'number'
									"
									class="topDiv mt-3"
								>
									<InputField
										:type="field.controlType"
										:label="field.label"
										:fieldType="field.fieldType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
										:showError="getError(field)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'single_select'"
									class="topDiv mt-3"
								>
									<SelectCustom
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:api="field.apiEndpoint"
										:values="field.values"
										:dropdown="field.dropdown"
										:fieldType="field.fieldType"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										:showError="getError(field)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'multi_select'"
									class="topDiv mt-3"
								>
									<MultiSelectCustom
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:api="field.apiEndpoint"
										:values="field.values"
										:dropdown="field.dropdown"
										:fieldType="field.fieldType"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										:showError="getError(field)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'rich_text_box'"
									class="topDiv mt-3"
								>
									<CustomQuillEditor
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
										:showError="getError(field)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'boolean'"
									class="topDiv mt-4"
								>
									<SwitchBox
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getCandidateData(field.key)"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'upload_file'"
									class="topDiv mt-3"
								>
									<UploadDocument
										:vmodel="getCandidateData(field.key)"
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'multi_text'"
									class="topDiv mt-3"
								>
									<FormTags
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:suggestions="getSuggestions(field.key)"
										@select-value="updateFieldValue(field, $event)"
										:vmodel="getCandidateData(field.key)"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'date'"
									class="topDiv mt-3"
								>
									<DateField
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										:showError="getError(field)"
										:format="field.dateTimeFormat"
									/>
								</div>

								<template v-if="touchedFields[field.key]">
									<div
										class="newInt-required-validation-font mt-1"
										:class="
											field.controlType == 'upload_file'
												? 'error-ml-2'
												: 'error-ml-1'
										"
										v-if="field.mandatory && !validateField(field)"
									>
										{{ valText[field.key] }}
									</div>
									<div
										class="newInt-required-validation-font mt-1"
										:class="
											field.controlType == 'upload_file'
												? 'error-ml-2'
												: 'error-ml-1'
										"
										v-else-if="field.limit > 0 && !validateField(field)"
									>
										{{ valText[field.key] }}
									</div>
								</template>
							</b-col>
						</b-row>

						<div
							class="d-flex align-items-center mt-4"
							v-if="advanceArray.length > 0"
						>
							<div @click="roundModalSvg = !roundModalSvg">
								<img
									v-if="roundModalSvg"
									src="../../assets/newdesign/inputcomponent/modalTopArrow.svg"
									alt=""
								/>
								<img
									v-else
									src="../../assets/newdesign/inputcomponent/modalDownArrow.svg"
									alt=""
								/>
							</div>
							<div class="cs-bluetxt ml-2 mr-3">Advanced</div>
							<div class="modal-horizontal-line"></div>
						</div>

						<b-row v-if="roundModalSvg">
							<b-col
								v-for="(field, index) in advanceArray"
								:key="index"
								:cols="getColumn(field.controlType)"
								class="relativeclass"
								:class="
									field.controlType == 'boolean'
										? 'd-flex align-items-center'
										: ''
								"
								v-show="!field.hide"
							>
								<div
									v-if="
										field.controlType == 'text' ||
										field.controlType == 'email' ||
										field.controlType == 'number'
									"
									class="topDiv mt-3"
								>
									<InputField
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
										:showError="getError(field)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'single_select'"
									class="topDiv mt-3"
								>
									<SelectCustom
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:api="field.apiEndpoint"
										:values="field.values"
										:vmodel="getCandidateData(field.key)"
										:dropdown="field.dropdown"
										:fieldType="field.fieldType"
										@select-value="updateFieldValue(field, $event)"
										:showError="getError(field)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'multi_select'"
									class="topDiv mt-3"
								>
									<MultiSelectCustom
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:api="field.apiEndpoint"
										:values="field.values"
										:vmodel="getCandidateData(field.key)"
										:dropdown="field.dropdown"
										:fieldType="field.fieldType"
										@select-value="updateFieldValue(field, $event)"
										:showError="getError(field)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'rich_text_box'"
									class="topDiv mt-3"
								>
									<CustomQuillEditor
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
										:showError="getError(field)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'boolean'"
									class="topDiv mt-4"
								>
									<SwitchBox
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getCandidateData(field.key)"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'upload_file'"
									class="topDiv mt-3"
								>
									<UploadDocument
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'multi_text'"
									class="topDiv mt-3"
								>
									<FormTags
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:suggestions="getSuggestions(field.key)"
										@select-value="updateFieldValue(field, $event)"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'date'"
									class="topDiv mt-3"
								>
									<DateField
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:vmodel="getCandidateData(field.key)"
										@select-value="updateFieldValue(field, $event)"
										:showError="getError(field)"
										:format="field.dateTimeFormat"
									/>
								</div>

								<template v-if="touchedFields[field.key]">
									<div
										class="newInt-required-validation-font mt-1"
										:class="
											field.controlType == 'upload_file'
												? 'error-ml-2'
												: 'error-ml-1'
										"
										v-if="field.mandatory && !validateField(field)"
									>
										{{ valText[field.key] }}
									</div>
									<div
										class="newInt-required-validation-font mt-1"
										:class="
											field.controlType == 'upload_file'
												? 'error-ml-2'
												: 'error-ml-1'
										"
										v-else-if="field.limit > 0 && !validateField(field)"
									>
										{{ valText[field.key] }}
									</div>
								</template>
							</b-col>
						</b-row>
					</div>
					<div
						class="candash-modal-footer d-flex align-items-center justify-content-end"
					>
						<b-button
							class="candash-cancelBtn mr-4 pointer"
							@click="$emit('close')"
							>Cancel</b-button
						>
						<div class="position-relative">
							<b-button
								class="candash-addBtn"
								@click="validateForm"
								:class="
									btnLoader ? 'loader-class-apply defaultCursor' : 'pointer'
								"
								:disabled="loader"
								>{{ btnLoader ? "" : "Apply" }}</b-button
							>
							<div v-if="btnLoader" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { getCandInfo, getAllProfiles } from "@/utils/apiFunctions";
import { getCandidateDetail } from "@/controllers/dashboard/asynchronous";
import InputField from "../../components/InputComponents/Input.vue";
import SwitchBox from "../../components/InputComponents/Switch.vue";
import CustomQuillEditor from "../../components/InputComponents/CustomQuillEditor.vue";
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom.vue";
import UploadDocument from "../../components/InputComponents/UploadDocument.vue";
import FormTags from "../../components/InputComponents/FormTags.vue";
import DateField from "../../components/InputComponents/DateField.vue";
import toast from "@/components/mixin/toast";
import {
	dynamicRules,
	getCustomFields,
	columnWidth,
	showError,
	validateField,
} from "../../utils/customField.js";
import {
	applyJob,
	getCandidateFilePaths,
	uploadJobDocuments,
} from "@/utils/apiFunctions";
import { mapGetters } from "vuex";
import FormShimmer from "../FormShimmer.vue";
import Loader from "../fixedcomponents/Loader.vue";
import SwitchProfile from "@/views/JobSearch/SwitchProfile.vue";
import { trackJobApplied } from '@/utils/posthogHelpers';
const candidateDataMapping = {
	name: "fullName",
	experince: "totalYearsOfExp",
	currentLocation: "city",
	currentCTC: "currentCTC",
	expectedCTC: "expectedCTC",
	noticePeriod: "noticePeriod",
	altPhoneNumber: "altPhoneNumber",
	gender: "gender",
	email: "displayEmail",
	name: "fullName",
};

const suggestionsMapping = {
	skills: "skillName",
};

export default {
	name: "ApplyJob",
	props: {
		job: Object,
		licenseKey: [String, Number],
		candidateData: Object,
	},
	mixins: [toast],
	data() {
		return {
			loader: false,
			resumePath: null,
			profileImagePath: null,
			roundModalSvg: true,
			btnLoader: false,
			advanceArray: [],
			basicArray: [],
			customFieldsArray: [],
			touchedFields: [],
			newObject: {},
			validations: {},
			valText: {},
			loopvar: 10,
			allProfileList: [],
			showProfileListLoader: false,
			searchQuery: "",
			selected: null,
			localCandidateInfo: {},
			selectedProfile: {},
			showDropdown: false,
		};
	},
	components: {
		InputField,
		SwitchBox,
		CustomQuillEditor,
		SelectCustom,
		MultiSelectCustom,
		UploadDocument,
		FormTags,
		DateField,
		FormShimmer,
		Loader,
		SwitchProfile,
		// Spinner,
	},
	async created() {
		this.loader = true;
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
	methods: {
		updateSelectedProfile(profile) {
			this.selectedProfile = profile;
			this.selected = profile._id;
		},
		updateProfileList(profileList) {
			this.allProfileList = profileList;
		},
		async switchProfile(pId) {
			this.showDropdown = false;
			this.loader = true;
			this.basicArray = [];
			this.advanceArray = [];
			this.localCandidateInfo._id = pId;
			this.localCandidateInfo = await getCandidateDetail(this);
			this.$store.commit(
				"candidateVUEX/setCandidateInfo",
				this.localCandidateInfo
			);
			if (pId) {
				this.selectedProfile = this.allProfileList.find(
					(obj) => obj?._id == pId
				);
				await this.getCandidateFilePaths(this.selectedProfile?._id);
			}
			await this.initializeData();
			this.candidateData = this.localCandidateInfo;
			this.loader = false;
		},
		async initializeData() {
			this.loader = true;
			try {
				const customFields = await getCustomFields("5", "add", this.licenseKey);

				if (customFields.length) {
					[this.customFieldsArray, this.newObject, this.touchedFields] =
						customFields;

					// Iterate through the original array and push objects into respective arrays based on category value
					this.customFieldsArray.forEach((obj) => {
						if (obj.category === 1 || obj.category === null) {
							this.basicArray.push(obj); // Push objects with category value 1 into category1Array
						} else if (obj.category === 2) {
							this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
						}
					});

					this.validations = dynamicRules(this.customFieldsArray);
					this.shimmerLoader = false;
					this.loader = false;
				} else {
					throw new Error("Something went wrong");
				}
			} catch (error) {
				console.log(error);
				this.$emit("close");
			} finally {
				this.loader = false;
			}
		},
		async getCandidateFilePaths(pID) {
			try {
				const res = await getCandidateFilePaths(pID);
				if (res.status == 200) {
					this.resumePath = res.data.data.resumePath;
					this.profileImagePath = res.data.data.profileImagePath;
				} else {
					throw new Error(res.data.data.Detail);
				}
			} catch (error) {
				console.error(error);
			}
		},
		validateForm() {
			let invalidForm = false;
			this.newObject["source"] = "other";
			this.newObject["otherSource"] = "Hire3x";
			for (let i = 0; i < this.customFieldsArray.length; i++) {
				const field = this.customFieldsArray[i];
				this.touchedFields[field.key] = true;
				this.$forceUpdate();
				if (!validateField(field, this)) {
					invalidForm = true;
				}
			}
			if (!invalidForm) {
				this.addCandidate();
			} else {
				this.errorModal("Error", "Please fill mandatory details");
			}
		},
		async addCandidate() {
			this.btnLoader = true;
			try {
				let fieldsExceptUploadTypes;
				fieldsExceptUploadTypes = JSON.parse(JSON.stringify(this.newObject));
				for (const field of this.customFieldsArray) {
					if (field.controlType === "upload_file") {
						if (field.fieldType === "default") {
							delete fieldsExceptUploadTypes[field.key];
						} else {
							delete fieldsExceptUploadTypes.customFields[field.key];
						}
					}
				}
				if (typeof this.newObject.resume != "object") {
					fieldsExceptUploadTypes.resume = this.newObject["resume"];
				}
				const res = await applyJob({
					emailID: this.candidateData.email,
					jobID: this.job.jobID,
					firstName: this.candidateData.firstName,
					lastName: this.candidateData.lastName,
					location: this.candidateData.city,
					phoneNumber: this.candidateData.phoneNumber,
					candidateInfo: {
						...fieldsExceptUploadTypes,
						userID: this.userInfo.userID,
						fields: this.customFieldsArray,
						profileID: this.selectedProfile?._id,
					},
				});
				if (res.status == 200) {
					const form = new FormData();
					/*
      {
        attachment: [
          {attachmentName: fieldKey, fieldType}
        ],
        fieldKey: [blob],
        jobID,
        emailID,
        licenseKey,
      }
      */

					var attachment = [];

					for (const field of this.customFieldsArray) {
						const value =
							field.fieldType === "default"
								? this.newObject[field.key]
								: this.newObject.customFields[field.key];
						if (
							field.controlType === "upload_file" &&
							value &&
							typeof value === "object"
						) {
							let obj = {
								attachmentName: field.key,
								fieldType: field.fieldType,
							};
							attachment.push(obj);
							form.append(field.key, value);
						}
					}
					form.append("attachment", JSON.stringify(attachment));
					form.append("jobID", this.job.jobID);
					form.append("licenseKey", this.job.licenseKey);
					form.append("email", this.candidateData.email);
					if (attachment.length) await uploadJobDocuments(form);
					trackJobApplied(this.job)
					this.$emit("success", this.job.jobID);
				} else {
					throw new Error(res.data.data.Detail);
				}
			} catch (error) {
				console.error(error);
				this.$emit("failure", error.message);
			} finally {
				this.btnLoader = false;
			}
		},
		getCandidateData(key) {
			if (key === "resume") {
				if (!this.resumePath) return null;
				const data = { data: { uploadFile: this.resumePath } };
				return data;
			} else if (key === "imageMedia") {
				const data = { data: { uploadFile: this.profileImagePath } };
				return data;
			} else if (key == "skills") {
				return Object.values(this.candidateData[key]).map(
					(skill) => skill.skillName
				);
			}
			if (candidateDataMapping[key]) {
				if (key == "noticePeriod") {
					const value = this.candidateData[candidateDataMapping[key]];
					return value ? value.toLowerCase() : "";
				}
				return this.candidateData[candidateDataMapping[key]];
			} else {
				return this.candidateData[key] || null;
			}
		},
		getSuggestions(key) {
			let suggestions = [];
			if (candidateDataMapping[key]) {
				suggestions = this.candidateData[candidateDataMapping[key]];
			} else {
				suggestions = this.candidateData[key] || [];
			}

			if (suggestions.length) {
				if (typeof suggestions[0] !== "object") return suggestions;
				else if (typeof suggestions[0] === "object") {
					if (suggestionsMapping[key]) {
						return suggestions.map(
							(suggestion) => suggestion[suggestionsMapping[key]]
						);
					}
				}
			}

			return [];
		},
		toTitleCase(string) {
			if (!string) return "";
			return string
				.split(" ")
				.map((w) => (w[0] ? w[0].toUpperCase() + w.slice(1) : w))
				.join(" ");
		},
		getColumn(field) {
			return columnWidth(field);
		},
		getError(field) {
			return showError(field, this.touchedFields[field.key], this);
		},
		getVmodel(field) {
			return field.fieldType == "default"
				? this.newObject[field.key]
				: this.newObject.customFields[field.key];
		},
		handleInput(field) {
			this.touchedFields[field.key] = true;
			this.$forceUpdate();
		},
		handleBlur(field) {
			if (this.touchedFields[field.key] && !this.validations[field.key]) {
				validateField(field, this);
				this.$forceUpdate();
			}
		},
		updateFieldValue(field, value) {
			if (field.fieldType === "default") {
				this.$set(this.newObject, field.key, value);
			} else {
				this.$set(this.newObject.customFields, field.key, value);
			}
			if (
				(field.key === "source" || field.key === "noticePeriod") &&
				value === "other"
			) {
				if (field.category === 1 || field.category === null) {
					const selectedIndex = this.basicArray.findIndex(
						(option) => option.seq === field.seq && option.hide
					);
					this.basicArray[selectedIndex].hide = false;
				} else {
					const selectedIndex = this.advanceArray.findIndex(
						(option) => option.seq === field.seq && option.hide
					);
					this.advanceArray[selectedIndex].hide = false;
				}
			}
			this.$forceUpdate();
			validateField(field, this);
		},
		validateField(field) {
			return validateField(field, this);
		},
	},
};
</script>

<style scoped>
.loader-class-apply {
	opacity: 0.5;
	height: 31px;
	width: 102px;
}
.loader-pos-apply {
	position: absolute;
	top: -54px;
	z-index: 1;
	left: 5px;
}

.error-ml-1 {
	margin-left: 29%;
}

.error-ml-2 {
	margin-left: 19%;
}
.switch-profile-btn-width {
	width: 200px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.switch-profile-drop-width {
	max-width: 105px;
}
</style>
<style>
.apply-modal-dropdown {
	background-color: #ffffff;
	box-shadow: 0px 1px 11px 0px #00000061;
	border-radius: 4px;
	padding: 10px;
	position: absolute;
	width: 305px;
	right: 0px;
	top: 32px;
	z-index: 21;
}
</style>
